import { ILine } from '@entities/line/line';

export const prepareMinMaxRange = (min: number, max: number): [number, number] => {
  // Normalize invalid and swapped inputs
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return [0, 1];
  }
  if (min > max) {
    [min, max] = [max, min];
  }

  // If both are exactly zero, provide a sensible default domain
  if (min === 0 && max === 0) {
    return [0, 1];
  }

  // Case: small, non-negative values (< 1) — keep precision and add padding
  if (min >= 0 && max < 1) {
    const paddedMin = Math.max(0, min - min * 0.05);
    const paddedMax = max + max * 0.05;

    const magnitude = Math.max(paddedMin, paddedMax);
    if (magnitude === 0) {
      return [0, 1];
    }

    // Choose decimal places to preserve meaningful precision
    const decimalPlaces = Math.max(0, Math.ceil(-Math.log10(magnitude)) + 1);
    const factor = Math.pow(10, decimalPlaces);
    const lower = Math.floor(paddedMin * factor) / factor;
    const upper = Math.ceil(paddedMax * factor) / factor;
    return [lower, upper];
  }

  // Case: modest non-negative values (< 10)
  if (min >= 0 && max < 10) {
    const paddedMin = Math.max(0, min - min * 0.05);
    const paddedMax = max + max * 0.05;
    return [Math.floor(paddedMin), Math.ceil(paddedMax)];
  }

  // General case: add padding and round to a coarse step based on magnitude
  const paddedMin = min - Math.abs(min) * 0.05;
  const paddedMax = max + Math.abs(max) * 0.05;

  const maxAbs = Math.max(Math.abs(paddedMin), Math.abs(paddedMax));
  const power = Math.max(0, Math.floor(Math.log10(maxAbs)) - 1); // keep ~2 significant digits
  const step = Math.pow(10, power);

  const lower = Math.floor(paddedMin / step) * step;
  const upper = Math.ceil(paddedMax / step) * step;
  return [lower, upper];
};

export const halfOfYearLabelRange = (items: ILine[]): number[] | null => {
  if (items.length && 365 < items.length) {
    let firstItem = items.at(0);

    // @ts-ignore
    let [day, month, year] = firstItem.date.split('-');
    let firstDate = new Date(+year, +month - 1, +day);

    let firstMonthNumber = firstDate.getMonth() + 1;
    let secondMonthNumber = new Date(firstDate.setMonth(firstDate.getMonth() + 6)).getMonth() + 1;

    return [firstMonthNumber, secondMonthNumber];
  }

  return null;
};
